<template>
    <div class="form-input">
        <label class="form-input__label">{{ label }}</label>
        <input :type="type" :name="name" :value="old(name)" :class="['form-input__input', {'is-invalid': errors(name)}]"/>
        <small class="form-input__help" v-if="help">{{ help }}</small>
        <span class="invalid-feedback" v-if="errors(name)">
            <strong>{{ errors(name) }}</strong>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        name: String,
        help: String,
        type: {
            default: () => 'text',
            type: String,
        },
    },
}
</script>
